import type { ComponentProps, ComponentType } from "react";
import { Link } from "react-router-dom";

import {
	CardDescription as BaseCardDescription,
	CardHeader as BaseCardHeader,
	CardTitle as BaseCardTitle,
} from "../../../components/ui/card";
import AuthLayout from "../layout/AuthLayout";
import JobSeekerRegistrationForm from "./JobSeekerRegistrationForm";

const CardHeader = BaseCardHeader as ComponentType<ComponentProps<"div">>;
const CardTitle = BaseCardTitle as ComponentType<ComponentProps<"div">>;
const CardDescription = BaseCardDescription as ComponentType<ComponentProps<"div">>;

function RegisterScreen() {
	return (
		<AuthLayout>
			<div className="py-12 flex flex-col h-full justify-center">
				<Link to="/" className="block md:hidden">
					<img
						src="/images/logo.png"
						alt="DProz Logo"
						className="p-2 mb-8 mx-auto"
						style={{
							width: "180px",
						}}
					/>
				</Link>
				<CardHeader className="mb-6 p-0">
					<CardTitle className="font-bold font-plus-jakarta text-xl">Your dream job is just a click away!</CardTitle>
					<CardDescription className="text-[#5C5C5C] text-base font-inter">
						Create your free account — it takes less than a minute.
					</CardDescription>
				</CardHeader>
				<JobSeekerRegistrationForm />
			</div>
		</AuthLayout>
	);
}

export default RegisterScreen;
